import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import { UpdateBatchInfo } from "../../services/BatchService";
import { NotificationManager } from "react-notifications";
import { GetUsers } from "../../services/usersService";

const locations = [
  "Madison 1",
  "Madison 2",
  "Madison 3",
];

const EditBatchDialog = ({ open, onClose, batch, onSave }) => {
  const [inUser, setInUser] = useState("");
  const [outUser, setOutUser] = useState("");
  const [location, setLocation] = useState("");
  const [inTime, setInTime] = useState("");
  const [outTime, setOutTime] = useState("");
  const [pinUser, setpInUser] = useState("");
  const [poutUser, setpOutUser] = useState("");
  const [batchEditHistory, setBatchEditHistory] = useState("");
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (batch) {
      setInUser(batch.inUser || "");
      setOutUser(batch.outUser || "");
      setLocation(batch.location || "");
      setInTime(batch.inTime || "");
      setOutTime(batch.outTime || "");

      setpInUser(batch.inUser || "");
      setpOutUser(batch.outUser || "");
      setBatchEditHistory(batch.batchEditHistory || "");
    }
  }, [batch]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const users = await GetUsers("ANALYSTS");
        setUsers(users);
      } catch (error) {
        NotificationManager.error("Failed to get Users:", error.message);
      }
    };
    fetchUsers();
  }, []);

  const handleSaveClick = async () => {
    let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser")).operator;
    const changes = [];

    const formatDate = (date) => {
      const d = new Date(date);
      return `${d.toLocaleDateString()} at ${d.toLocaleTimeString()}`;
    };

    const addHistory = (field, oldValue, newValue) => {
      if (oldValue !== newValue) {
        const timestamp = new Date().toLocaleString();
        changes.push(
          `${field} changed from "${oldValue}" to "${newValue}" by ${loggedInUser} on ${timestamp}`
        );
      }
    };

    addHistory("In User", pinUser, inUser);
    addHistory("Out User", poutUser, outUser);
    addHistory("Location", batch.location, location);
    addHistory("In Time", formatDate(batch.inTime), formatDate(inTime));
    addHistory("Out Time", formatDate(batch.outTime), formatDate(outTime));

    const newBatchEditHistory = batchEditHistory
      ? batchEditHistory + "\n" + changes.join("\n")
      : changes.join("\n");

    const updatedBatch = {
      ...batch,
      inUser,
      outUser,
      location,
      inTime,
      outTime,
      batchEditHistory:  newBatchEditHistory+"(At Batch Manager)_____",
    };

    try {
      const response = await UpdateBatchInfo(updatedBatch, updatedBatch.id);
      onSave(response);
      onClose();
      NotificationManager.success("Changes Saved");
    } catch (error) {
      NotificationManager.error("Failed to save the batch:", error.message);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit Batch</DialogTitle>
      <DialogContent>
        <div className="columns">
          <div className="column">
            <label htmlFor="inUser" className="label">
              {`Previous In User: ${pinUser}`}
            </label>
            <select
              id="inUser"
              className="input"
              value={inUser}
              onChange={(e) => setInUser(e.target.value)}
              fullWidth
              margin="normal"
            >
              {users.map((user) => (
                <option key={user} value={user.trim()}>
                  {user.trim()}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="columns">
          <div className="column">
            <label htmlFor="outUser" className="label">
              {`Previous Out User: ${poutUser}`}
            </label>
            <select
              id="outUser"
              className="input"
              value={outUser}
              onChange={(e) => setOutUser(e.target.value)}
              fullWidth
              margin="normal"
            >
              {users.map((user) => (
                <option key={user} value={user.trim()}>
                  {user.trim()}
                </option>
              ))}
            </select>
          </div>
        </div>
        <TextField
          select
          label="Location/Incubator"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          fullWidth
          margin="normal"
        >
          {locations.map((loc) => (
            <MenuItem key={loc} value={loc}>
              {loc}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="In Time"
          type="datetime-local"
          value={inTime}
          onChange={(e) => setInTime(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Out Time"
          type="datetime-local"
          value={outTime}
          onChange={(e) => setOutTime(e.target.value)}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSaveClick} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditBatchDialog;
